import { Component, OnDestroy, Signal } from '@angular/core';
import { LocalisationForm } from './forms/localisation.form';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { stages } from '../../localisation-devices-unrelated-to-road.routes';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { updateParcels } from '../../../../../../store/actions/application.actions';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { ParcelsCrudComponent } from '../../../common/components/parcels/parcels-crud/parcels-crud.component';
import { NgxMaskDirective } from 'ngx-mask';
import { AlertComponent } from '../../../../../../common/alert/alert.component';

@Component({
  selector: 'app-localisation-data-section',
  standalone: true,
  imports: [
    StagesComponent,
    CommonModule,
    SpinnerComponent,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    ParcelsCrudComponent,
    NgxMaskDirective,
    AlertComponent
  ],
  providers: [LocalisationForm],
  templateUrl: './localisation-data-section.component.html'
})
export class LocalisationDataSectionComponent implements OnDestroy {

  public stages = stages;

  public applicationId: string | undefined = this.route.snapshot.params['appId'];

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store$: Store,
    public form: LocalisationForm
  ) {
  }

  public submitAndGoNext(): void {
    const currentApp = this.application();
    if (this.form.valid && currentApp) {
      this.store$.dispatch(updateParcels({
        currentApp,
        payload: this.form.toWriteModel(),
        parcels: this.form.parcelsValues,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
